module.exports = __webpack_public_path__ + "static/controle-2-lilas-a6d373c42c06bcd834acf499f94b9bc6.png";